import { Stack } from "@mui/system";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ImageAssets from "../../../../assets";
import { MuiButton } from "../../../../components/common/button/MuiButton";
import styles from "../../UserManagement.module.css";
import EmailVerification from "./EmailVerification";
import MobileVerification from "./MobileVerification";
import PersonalisationV1 from "./PersonalisationV1";

const RegistrationV1 = () => {
    const navigate = useNavigate();
    const loginState = useSelector((state: any) => state.Login);
    const [activeStep, setActiveStep] = useState(0);

    console.log(loginState?.draftUserData, "loginState?.draftUserData")

    return (
        <>
            {activeStep === 0 ?
                <EmailVerification setActiveStep={setActiveStep} activeStep={activeStep} />
                : activeStep === 1 ?
                    <MobileVerification setActiveStep={setActiveStep} activeStep={activeStep} />
                    : <PersonalisationV1 setActiveStep={setActiveStep} activeStep={activeStep} />
            }
        </>
    );
}
export default RegistrationV1;